.logTable {
  min-width: 100%;
}

.logTable :global(table) {
  min-width: 40rem;
}

.logTable :global(thead tr) {
  background: var(--color-surface-subtle);
}

.logTable :global(tbody tr) {
  background: transparent;
}

.logTable :global(tbody tr:hover) {
  background: var(--color-card-hover);
}

.logTable :global(tbody td) {
  vertical-align: top;
  padding-block: 0.75rem;
}

.eventCell {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.75rem;
}

/* Unread events carry a dot on their icon; reading the event clears it. */
.unreadDot {
  position: absolute;
  top: -0.1875rem;
  inset-inline-end: -0.1875rem;
  width: 0.5rem;
  height: 0.5rem;
  border: 2px solid var(--color-card);
  border-radius: 999px;
  background: var(--color-primary);
  box-sizing: content-box;
}

.meta {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem 0.75rem;
  margin-top: 0.375rem;
}

.eventType {
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 0.6875rem;
  color: var(--color-muted);
}

.detailsToggle {
  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  border-radius: var(--radius-sm);
  color: var(--color-muted);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: var(--color-foreground);
  }
}

.detailsChevron {
  transition: transform 150ms;
}

.detailsChevron.expanded {
  transform: rotate(180deg);
}

.details {
  margin-top: 0.5rem;
  max-width: 36rem;
  font-size: 0.8125rem;
}

.time {
  display: block;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
